import type {
  EarthingMeasurement,
  EarthingMeasurementsByNode,
} from '../services/controlTaskService';

export const normalizeEarthingMeasurementDidNotTrip = (
  measurement: EarthingMeasurement,
): EarthingMeasurement => {
  const didNotTrip = measurement.rcdTripCurrentDidNotTrip === true
    || measurement.rcdTripTimeDidNotTrip === true;
  return {
    ...measurement,
    rcdTripCurrentMa: didNotTrip ? null : measurement.rcdTripCurrentMa,
    rcdTripCurrentDidNotTrip: didNotTrip,
    rcdTripTimeMs: didNotTrip ? null : measurement.rcdTripTimeMs,
    rcdTripTimeDidNotTrip: didNotTrip,
  };
};

const prepareMeasurement = (measurement: EarthingMeasurement): EarthingMeasurement => {
  const normalized = normalizeEarthingMeasurementDidNotTrip(measurement);
  return {
    id: normalized.id,
    clientKey: normalized.id == null ? normalized.clientKey : undefined,
    measurementPointGroup: normalized.measurementPointGroup,
    measurementPointDescription: normalized.measurementPointDescription,
    measurementEnvironmentCondition: normalized.measurementEnvironmentCondition,
    rcdRatingMa: normalized.rcdRatingMa,
    toroidRatingA: normalized.toroidRatingA,
    protectiveConductorCrossSectionMm2: normalized.protectiveConductorCrossSectionMm2,
    ratedCurrentA: normalized.ratedCurrentA,
    tripCurveTypeOrModel: normalized.tripCurveTypeOrModel,
    phaseEarthLoopImpedanceOhm: normalized.phaseEarthLoopImpedanceDash
      ? null : normalized.phaseEarthLoopImpedanceOhm,
    phaseEarthLoopImpedanceDash: normalized.phaseEarthLoopImpedanceDash ?? false,
    phaseNeutralLoopImpedanceOhm: normalized.phaseNeutralLoopImpedanceOhm,
    rcdTripCurrentMa: normalized.rcdTripCurrentMa,
    rcdTripCurrentDidNotTrip: normalized.rcdTripCurrentDidNotTrip,
    rcdTripTimeMs: normalized.rcdTripTimeMs,
    rcdTripTimeDidNotTrip: normalized.rcdTripTimeDidNotTrip,
    compliance: normalized.compliance,
    complianceOverridden: normalized.complianceOverridden ?? false,
  };
};

/**
 * Sends complete editable row values while excluding backend-calculated metadata.
 * Explicit empty node lists are retained so deleting all rows remains possible.
 */
export const prepareEarthingMeasurementsForSubmit = (
  measurementsByNode: EarthingMeasurementsByNode,
): EarthingMeasurementsByNode => Object.fromEntries(
  Object.entries(measurementsByNode).map(([nodeId, measurements]) => [
    nodeId,
    measurements.map(prepareMeasurement),
  ]),
);
